import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';



@NgModule({
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatStepperModule,
    MatExpansionModule,
    MatTabsModule,
    MatTableModule,
    MatDialogModule,
    MatListModule
  ],
  exports: [
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatStepperModule,
    MatExpansionModule,
    MatTabsModule,
    MatTableModule,
    MatDialogModule,
    MatListModule
  ]
})
export class MaterialModule { }
